// 检测苹果设备类型
function detectAppleDevice() {
  const platform = navigator.platform;
  const userAgent = navigator.userAgent;
  const isTouchDevice = 'ontouchend' in document;

  // 移除已存在的类名，避免重复添加
  const appleClasses = ['os-ios', 'os-ipados', 'os-macos'];
  appleClasses.forEach(cls => {
    document.documentElement.classList.remove(cls);
  });
  // 检测iOS设备（iPhone/iPod）
  if ([
    'iPhone Simulator',
    'iPod Simulator',
    'iPhone',
    'iPod'
  ].includes(platform)) {
    document.documentElement.classList.add('os-ios');
    return;
  }

  // 检测iPadOS设备
  if ([
    'iPad Simulator',
    'iPad'
  ].includes(platform) || (userAgent.includes('Mac') && isTouchDevice)) {
    document.documentElement.classList.add('os-ipados');
    return;
  }

  // 检测MacOS设备
  if (platform.includes('Mac') && !isTouchDevice) {
    document.documentElement.classList.add('os-macos');
    return;
  }
}

// 执行检测
detectAppleDevice();
